import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RightSideComponent from "../components/setting-component/RightSideComponent";
import SettingSideMenu from "../components/setting-component/SettingSideMenu";
import { NoModuleRights } from "../utils/utils";

const Setting = () => {
  const location = useLocation();

  const [subCategories, setSubCategories] = useState("profile");

  const profileRights = NoModuleRights("Profile");
  const manageProjectsRights = NoModuleRights("Manage Projects");

  useEffect(() => {
    setSubCategories(!profileRights ? "profile" : !manageProjectsRights ? "manageProjects" : "share");
  }, [profileRights, manageProjectsRights]);

  useEffect(() => {
    if (location.state) {
      setSubCategories(location?.state?.status);
    }
  }, []);

  return (
    <>
      <div className="dashbord-content">
        <div className="dashbord-content-inner">
          <SettingSideMenu
            subCategories={subCategories}
            setSubCategories={setSubCategories}
          />
          <div className="content-right-box">
            <div className="intro-table-search container-fluid">
              <RightSideComponent
                subCategories={subCategories}
                setSubCategories={setSubCategories}
              />
            </div>
          </div>
          {/* <CreateDocument /> */}
        </div>
      </div>
    </>
  );
};

export default Setting;
